<div class="modal" id="revokeStateDataPopup" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    {{popupHeaderTexts.enableDomains}}
                </h5>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
            </div>
            <div class="modal-body">

                <app-app-states-static [tableConfigOptions]="stateGridConfigData" [rowData]="revokeStatedata"
                    [formSide]="appSide.storeSide"></app-app-states-static>

            </div>
            <div class="modal-footer">
                <button type="button" id="{{createIdString()}}-closeBtn" 
                    class="btn btn-sm btn-secondary" (click)="closeRevokeStateDataPopup()">Close</button>
            </div>
        </div>
    </div>
</div>